import React from "react";
import { VimeoBase } from "./vimeo.styled";

interface IVimeoProps {
  iframeHtml: string | null;
}

const Vimeo = (props: IVimeoProps) => {
  const { iframeHtml } = props;

  return <VimeoBase dangerouslySetInnerHTML={{ __html: `${iframeHtml}` }} />;
};

export default Vimeo;
